import React from 'react';

import { Panel, Panels, spacing } from '~/src/dash/publicaUI';
import { ButtonsDemo } from '~/src/dash/views/sandbox/Sandbox/TextAndButtonsDemo/ButtonsDemo';
import { TextDemo } from '~/src/dash/views/sandbox/Sandbox/TextAndButtonsDemo/TextDemo';

export const TextAndButtonsDemo = () => {
  return (
    <Panels relative flexDirectionBreakSize='medium'>
      <Panel
        highlighted
        flex
        responsive
        style={{
          marginRight: spacing.extraSmall,
        }}
        mediumStyle={{
          marginRight: spacing.none,
          marginBottom: spacing.small,
        }}
      >
        <TextDemo />
      </Panel>
      <Panel
        highlighted
        flex
        responsive
        style={{
          marginLeft: spacing.extraSmall,
        }}
        mediumStyle={{
          marginLeft: spacing.none,
        }}
      >
        <ButtonsDemo />
      </Panel>
    </Panels>
  );
};
